export default __webpack_public_path__ + "static/media/image.4a9441e5.png";